import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconChristmasTree } from '@redteclab/icons'

type ProductBuyBoxChristmasCommunicationProps = {
  isCoolingProduct: boolean
}

export const ProductBuyBoxChristmasCommunication: FC<
  ProductBuyBoxChristmasCommunicationProps
> = ({ isCoolingProduct }) => {
  return (
    <div className="mb-3 w-full rounded-3xl bg-light-primary-low p-4">
      <div className="flex">
        <div>
          <div className="mr-2.5 flex size-12 items-center justify-center rounded-full bg-light-brand-medium">
            <IconChristmasTree className="size-6 fill-dark-primary-max" />
          </div>
        </div>
        <div className="flex flex-col">
          <span className="text-s font-medium text-dark-primary-max">
            {isCoolingProduct ? (
              <FormattedMessage id="christmas.communication.delivery.date.cooling" />
            ) : (
              <FormattedMessage id="christmas.communication.delivery.date.otc" />
            )}
          </span>
          <span className="mt-1 text-xs text-dark-primary-strong">
            <FormattedMessage id="now.delivery.excluded" />
          </span>
        </div>
      </div>
    </div>
  )
}
